// extracted by mini-css-extract-plugin
export var actions = "_6l-8";
export var arrow = "_6l-5";
export var card = "_6l-0";
export var cardWrapper = "_6l-9";
export var fieldName = "_6l-3";
export var newValue = "_6l-6";
export var oldValue = "_6l-4";
export var orangeGlowFade = "_6l-c";
export var productSection = "_6l-1";
export var scrollToBottom = "_6l-b";
export var scrollToBottomAnchor = "_6l-a";
export var scrollToBottomIcon = "_6l-d";
export var showAllButton = "_6l-7";
export var table = "_6l-2";